import React, { useState } from 'react';

export default function Main() {

    const [player, setPlayer] = useState({ name: '', chips: 0});
    const [cards, setCards] = useState([]);
    const [sum, setSum] = useState(0);
    const [hasBlackJack, setHasBlackJack] = useState (false);
    const [isAlive, setIsAlive] = useState(false);
    const [message, setMessage] = useState('Play a round?'); 
    const [gameStarted, setGameStarted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    
    function getRandomCard() {
        let randomNumber = Math.floor(Math.random() * 13) +1;
        if (randomNumber > 10) {
            return 10;
        } else if (randomNumber === 1) {
            return 11;
        } else {
            return randomNumber;
        }
    }

    function startGame() {
        if (!gameStarted || !isAlive) {
        setIsAlive(true);
        let firstCard = getRandomCard();
        let secondCard = getRandomCard();
        setCards([firstCard, secondCard]);
        setSum(firstCard + secondCard);
        setGameStarted(true);
        setMessage('Play a round?');
    }
}

    function newCard() {
        if (isAlive === true && hasBlackJack === false) {
            let card = getRandomCard();
            setSum(sum + card);
            setCards([...cards, card]);
        

        if (sum + card <= 20) {
            setMessage('Do you want to draw a new card?')
        } else if (sum + card === 21) {
            setMessage('You have Blackjack!');
            setHasBlackJack(true);
            setIsAlive(false);
            setPlayer({ ...player, chips: 100})
        } else {
            setMessage('You are out of the game!')
            setIsAlive(false);
        }
    }
}

function handleNameChange(event){
    setPlayer({ ...player, name: event.target.value});
}

function submitName(event) {
    event.preventDefault();
    setIsSubmitted(true);
}

    return(
        <main>
            <div> 
                <h1 className='message-el'>{message}</h1>
                    <div className='main--play-area'>
                        <h2 className='cards-el'>Cards: {cards.join(' ')}</h2>
                        <h2 className='sum-el'>Sum: {sum}</h2>
                        <div className='main--buttons-container'>
                        <button onClick={startGame}>Start Game</button>
                        <button onClick={newCard}>New Card</button>
                    </div>
                </div>
                {isSubmitted ? (
          <h2 className='player-el'>{player.name} - ${player.chips}</h2>
        ) : (
          <form onSubmit={submitName}>
            <label>
              Name: 
              <input
                type='text'
                placeholder='Enter your name here'
                value={player.name}
                onChange={handleNameChange}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    submitName(e);
                  }
                }}
              />
            </label>
          </form>
        )}
            </div>
        </main>
    )
}